// src/components/Common/MegaMenu.js
"use client";

import { useState } from "react";
import { Link } from "react-router-dom";
import { megaMenuItems } from "../../data/megaMenu";

const MegaMenu = () => {
  const [activeKey, setActiveKey] = useState(megaMenuItems[0].key);

  const activeMenu = megaMenuItems.find(m => m.key === activeKey);

  return (
    <li className="nav-item dropdown mega-dropdown">
      <span className="nav-link dropdown-toggle fs-16 fw-medium cursor-pointer">
        نمونه‌ها
      </span>

      <div className="dropdown-menu mega-menu shadow-lg border-0 p-4">
        <div className="row">
          {/* ستون عناوین اصلی */}
          <div className="col-4 border-end">
            <ul className="list-unstyled mb-0">
              {megaMenuItems.map(item => (
                <li
                  key={item.key}
                  className={`py-2 px-3 rounded ${
                    activeKey === item.key ? "bg-light fw-semibold" : ""
                  }`}
                  onMouseEnter={() => setActiveKey(item.key)}
                  style={{ cursor: "pointer" }}
                >
                  {item.title}
                </li>
              ))}
            </ul>
          </div>

          {/* ستون زیرمنو */}
          <div className="col-8">
            <h6 className="fw-semibold mb-3">{activeMenu.title}</h6>
            <div className="row">
              {activeMenu.items.map((sub, i) => (
                <div key={i} className="col-6 mb-2">
                  <Link
                    to={sub.to}
                    className="text-decoration-none text-body hover-primary"
                  >
                    {sub.label}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

export default MegaMenu;
